export { wrapRootElement } from './gatsby-ssr';
